import { useCallback, useEffect, useState } from 'react';
export const useStickyHeader = (tableRef, topOffset) => {
    const [isSticky, setIsSticky] = useState(false);
    const handleScrollChange = useCallback(({ top, bottom }) => {
        let sticky = isSticky;
        if (top <= (topOffset || 0) && bottom > 0) {
            sticky = !isSticky ? true : sticky;
        }
        else {
            sticky = isSticky ? false : sticky;
        }
        if (sticky !== isSticky)
            setIsSticky(sticky);
    }, [isSticky, topOffset]);
    useEffect(() => {
        const onScroll = () => {
            var _a;
            if (tableRef.current) {
                handleScrollChange((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect());
            }
        };
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [handleScrollChange, tableRef]);
    return { isSticky };
};
//# sourceMappingURL=hooks.js.map